/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-11-15 10:51:47
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-11-17 20:49:07
 * @FilePath: \mpc-monorepo\features\mpc-common\src\features\MPCDemand\KOLInquiryForQuotation\cells\SupplierCell\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useMemo } from 'react';
import { Space, Tag, Tooltip } from '@bedrock/components';
import classNames from 'classnames/bind';
import styles from './index.less';
import {
  EllipsisTooltip,
  CellDescriptions,
  priceFormat,
} from '@mpc/components';
import { HelpCircle, LevelDown } from '@bedrock/icons-react';
import { CurrencyEnum } from '#services/api';
import MPCProCurrency from '#components/MPCProCurrency';
import { KOLDemandCategory } from '../../KOLTable/type';
import LookQuoteRemarkModal from './LookQuoteRemarkModal';

const cx = classNames.bind(styles);

interface SupplierCellProps {
  record: any;
  /** 类型：直播单、图文单 */
  category?: KOLDemandCategory;
  /** 视图币种 */
  viewCurrency?: CurrencyEnum;
}

/**
 * 供应商信息展示组件
 */
const SupplierCell: React.FC<SupplierCellProps> = ({
  category,
  viewCurrency,
  record,
}) => {
  const { supplierName, isLowestPrice, initialQuote, quoteCurrency, cpm15, cpmPV, cpmUV } = useMemo(() => {
    return {
      supplierName: record.demand_source_supplier_vo?.supplier_name ?? '-',
      isLowestPrice: record.lowest_price,
      initialQuote: record.quote_price,
      quoteCurrency: record.quote_price_currency,
      cpm15: record.cpm,
      cpmPV: record.cpm_pv,
      cpmUV: record.cpm_uv,
    }
  },[record])

  return (
    <div>
      {supplierName && (
        <div className={cx('supplier-name')}>
          <span>{supplierName}</span>
          {isLowestPrice && (
            <Tag
              text="最低价"
              color="light-green"
              border={true}
              size="xSmall"
              icon={<LevelDown />}
              className="whitespace-nowrap"
            />
          )}
        </div>
      )}

      <CellDescriptions
        column={1}
        maxDisplayCount={3}
        items={[
          {
            label: '初次报价',
            show: true,
            children: (
              <Space size="xxs">
              <MPCProCurrency
                viewCurrency={viewCurrency}
                fieldProps={{
                  value: { currency: quoteCurrency, amount: initialQuote },
                  currencyBeforeAmount: false,
                  highlight: false,
                }}
              />
              <Tooltip title="点击查看报价备注">
                <HelpCircle onClick={() => {
                  LookQuoteRemarkModal.show({ record })
                }} />
              </Tooltip>
              </Space>
            ),
          },
          {
            label: '平均15日CPM',
            show: category === 'text_and_image',
            children: <EllipsisTooltip clamp={1} text={cpm15?.toLocaleString?.() || '--'} />,
          },
          {
            label: '直播CPM(PV)',
            show: category === 'live',
            children: <EllipsisTooltip clamp={1} text={cpmPV?.toLocaleString?.() || '--'} />,
          },
          {
            label: '直播CPM(UV)',
            show: category === 'live',
            children: <EllipsisTooltip clamp={1} text={cpmUV?.toLocaleString?.() || '--'} />,
          },
        ].filter(item => item.show)}
      />
    </div>
  );
};

export default SupplierCell;
